import { createContext, useEffect, useState } from "react";
import Routing from "./Routing";
import api from "./services/api";
import WelcomeModal from "./components/pages/WelcomeModal";
import Cookies from "js-cookie";
import { AuthProvider } from "./services/AuthContext";

export const HeyatYoluContext = createContext();

function App() {
  const [user, setUser] = useState(null);
  const [religions, setReligions] = useState([]);
  const [relationTypes, setRelationTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [todayProfiles, setTodayProfiles] = useState([]);
  const [paymentAmount, setPaymentAmount] = useState("2.20");
  const [paymentEnabled, setPaymentEnabled] = useState(true); // ← YENİ

  // Modal state
  const [guestModal, setGuestModal] = useState(false);
  const [userModal, setUserModal] = useState(false);

  // Emosional mətnlər
  const guestText =
    "Hər kəsin bir sevdiyi var ki, dünyasını dəyişsə də, qəlbimizdən silinmir.\n\n" +
    "Gəlin onları unudulmağa qoymayaq — xatirələrini gələcək nəsillər üçün də yaşadaq.";

  const userText =
    "Artıq siz də xatirələri yaşadanlar arasındasınız.\n\n" +
    "Hazırsınızsa, sevdiyinizin xatirəsini yaratmaq üçün ilk addımı ata bilərsiniz.";

  // Backend sorğuları
  useEffect(() => {
    Promise.all([
      api.get("/account/me")
        .then((res) => setUser(res.data))
        .catch(() => setUser(null)),
      api.get("/religion").then((res) => setReligions(res.data)),
      api.get("/relationtype").then((res) => setRelationTypes(res.data)),
      api.get("/memorialprofile/today?page=1&pageSize=6")
        .then((res) => setTodayProfiles(res.data.data)),
      // ← DƏYİŞDİ: current-amount əvəzinə config (məbləğ + aktiv/deaktiv)
      api.get("/payment/config")
        .then((res) => {
          setPaymentAmount(Number(res.data.amount).toFixed(2));
          setPaymentEnabled(res.data.paymentEnabled);
        })
        .catch(() => {
          // Xəta olsa default qalır: 2.20 AZN, ödəniş aktiv
        }),
    ]).finally(() => setLoading(false));
  }, []);

  // Qonaq üçün modal — yalnız 1 dəfə
  useEffect(() => {
    if (!user && !localStorage.getItem("guestWelcomeShown")) {
      const timer = setTimeout(() => {
        setGuestModal(true);
        localStorage.setItem("guestWelcomeShown", "true");
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [user]);

  // Qeydiyyatdan keçmiş user üçün modal — yalnız 1 dəfə
  useEffect(() => {
    if (user && !localStorage.getItem("userWelcomeShown")) {
      const timer = setTimeout(() => {
        setUserModal(true);
        localStorage.setItem("userWelcomeShown", "true");
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [user]);
  // 🔥 İlk giriş zamanı URL-dən referral kodu oxuyub cookie-yə yaz
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");

    if (ref) {
      Cookies.set("referralCode", ref, {
        expires: 7,  // 7 gün yadda saxlanacaq
        path: "/",
      });
    }
  }, []);

  const DataBase = {
    user,
    setUser,
    religions,
    relationTypes,
    todayProfiles,
    paymentAmount,
    paymentEnabled, // ← YENİ
  };

  if (loading) {
    return (
      <div className="app-loading">
        <div className="spinner" />
      </div>
    );
  }

  return (
    <HeyatYoluContext.Provider value={DataBase}>
      <div className="App">
        <AuthProvider>
          <Routing />
        </AuthProvider>

        {/* WELCOME MODALS */}
        <WelcomeModal
          text={guestText}
          show={guestModal}
          onClose={() => setGuestModal(false)}
          type="guest"
        />

        <WelcomeModal
          text={userText}
          show={userModal}
          onClose={() => setUserModal(false)}
          type="user"
        />
      </div>
    </HeyatYoluContext.Provider>
  );
}

export default App;